import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, SimpleGrid, Spinner } from '@chakra-ui/react';
import { ContentTrackCardSmall } from '@src/components/sco/Education/HomeLanding/Addons/ContentTrackCardSmall';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql } from '@src/lib/gql';
import React from 'react';
type ContentTrackListFeaturedProps = {};
export const ContentTrackListFeatured = props => {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ContentTrackListFeatured.queries.contentTracks();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[1] !== query.loading) {
    t1 = query.loading && <Center><Spinner /></Center>;
    $[1] = query.loading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== query.error) {
    t2 = query.error && <Box>{query.error?.toString()}</Box>;
    $[3] = query.error;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getBreakpointValue) {
    t3 = getBreakpointValue([2, 3, 3, 3, 6]);
    $[5] = getBreakpointValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== getBreakpointValue) {
    t4 = getBreakpointValue([4, 4, 10]);
    $[7] = getBreakpointValue;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== query.data?.contentTracks) {
    t5 = query.data?.contentTracks?.map(_temp);
    $[9] = query.data?.contentTracks;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <SimpleGrid columns={t3} gap={4} paddingBottom={t4}>{t5}</SimpleGrid>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t6) {
    t7 = <Box>{t1}{t2}{t6}</Box>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
ContentTrackListFeatured.fragments = {
  ContentTrack: () => gql`
    fragment _ on ContentTrack {
      id
      title
      slug
      type
      shortDescription
      terms {
        id
        name
      }
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
      }
      terms {
        id
        name
      }
    }
  `
};
ContentTrackListFeatured.queries = {
  contentTracks: () => gql`
    query {
      contentTracks(where: { type_in: [Bootcamp, Course, Track] }) {
        id
        color {
          hex
        }
        ${ContentTrackListFeatured.fragments.ContentTrack()}
      }
    }
  `
};
function _temp(contentTrack, index) {
  return <ContentTrackCardSmall key={contentTrack.id} contentTrack={contentTrack} />;
}